// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-reader {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  border: 1px solid #c6cfdd;
  border-radius: 5px;
  margin-top: 10px;
}

.qr-reader video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qr-reader .qr-box {
  width: 100% !important;
  left: 0 !important;
}

.qr-reader .qr-frame {
  position: absolute;
  fill: none;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/qrscanner/QrStyles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,4CAA4C;AAC9C","sourcesContent":[".qr-reader {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n  border: 1px solid #c6cfdd;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.qr-reader video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.qr-reader .qr-box {\n  width: 100% !important;\n  left: 0 !important;\n}\n\n.qr-reader .qr-frame {\n  position: absolute;\n  fill: none;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
